import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {AccReceivableReportData} from "./acc-receivable-report.data";

@Injectable()
export class AccReceivableReportModel extends ReportModel<AccReceivableReportData> {
    constructor(injector: Injector) {
        super(injector, AccReceivableReportData);
    }
}
